var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"sj-loading",style:({
    zIndex: _vm.zIndex,
  })},[_c('div',{staticClass:"sj-loading-spinner"})])}
var staticRenderFns = []

export { render, staticRenderFns }